import { Noop } from 'types/common.interface';

import ModalPortal from 'components/modal/ModalPortal';

import WheelOfFortuneHistoryTable from './WheelOfFortuneHistoryTable';

interface WheelOfFortuneHistoryModalProps {
  onClose: Noop;
}

/**
 * Spin history, in its own modal.
 *
 * It used to expand inline underneath the wheel, which pushed the wheel modal past the
 * viewport and was the reason that modal had to scroll at all. As a modal it is also the
 * only surface here that scrolls — the table is unbounded in length, while everything
 * around the wheel is not.
 *
 * History is deliberately unified across both wheels, matching the API: one ledger, with
 * the source column saying where each entry came from.
 */
const WheelOfFortuneHistoryModal = ({ onClose }: WheelOfFortuneHistoryModalProps) => (
  <ModalPortal
    title="Spin/Rewards History"
    onClose={onClose}
    modalContentClassName="wof-history-modal-content tw-w-full tw-px-5 tw-pb-8 tw-pt-5 md:tw-max-w-screen-md lg:tw-px-10"
    titleClassName="!tw-text-[28px]"
    // Sits on top of the wheel modal, which stays mounted underneath.
    backdropOpacity={0.85}
  >
    <WheelOfFortuneHistoryTable />
  </ModalPortal>
);

export default WheelOfFortuneHistoryModal;
